/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { MarketSelector, Text, Checkbox, ExportModal } from '../uiold';
import { themeColors } from '../uiold/Constants';
import DataStore from '../../support/DataStore';
import DownloadTarget from '../../support/DownloadTarget';
import FormSection from '../VendorList/FormSection';
import mapToPlainObject from '../../support/mapToPlainObject';

import IndexedList from '../../support/shared/IndexedList';
import { Market } from '../../types/shared/Market';
import { Account } from '../../types/shared/Account';
import { Tag } from '../../types/shared/Tag';
import { VendorSummaryWithMarkets } from '../../types/shared/Vendor';

let dataStore = DataStore.getInstance('app');

type Props = {
  tags: Array<Tag>;
  account: Account | null | undefined;
  onHide: () => void;
  markets: IndexedList<Market> | null | undefined;
};

type State = {
  isLoading: boolean;
  selectedMarketDates: Map<string, Set<string>>;
  filterText: string;
  vendors: Array<VendorSummaryWithMarkets> | null | undefined;
  vendorCount: number;
  withTags: boolean;
  withEmails: boolean;
};

class ExportPlacement extends Component<Props, State> {
  state: State = {
    isLoading: false,
    selectedMarketDates: new Map(),
    filterText: '',
    vendors: [] as Array<VendorSummaryWithMarkets>,
    vendorCount: 0,
    withTags: false,
    withEmails: false,
  };

  render() {
    let { markets } = this.props;
    let { isLoading, withTags, withEmails } = this.state;

    return (
      <ExportModal
        title="Export Placement"
        isLoading={isLoading}
        onSubmit={this._onSubmit}
        onClose={this._onHide}
      >
        <>
          {!!markets && this._renderMarketDatesFormField()}
          <View style={styles.optionsWrapper}>
            <View style={{ width: '100%' }}>
              <FormSection
                zIndex={4}
                title="Tags"
                subtitle="Exports with tags"
              />
            </View>
            <View style={styles.checkbox}>
              <Checkbox isChecked={withTags} onChange={this._checkBoxTags} />
            </View>
          </View>
          <View style={styles.optionsWrapper}>
            <View style={{ width: '100%' }}>
              <FormSection
                zIndex={4}
                title="Emails"
                subtitle="Export with emails"
              />
            </View>
            <View style={styles.checkbox}>
              <Checkbox isChecked={withEmails} onChange={this._checkBoxEmail} />
            </View>
          </View>
        </>
      </ExportModal>
    );
  }

  _renderMarketDatesFormField = () => {
    return (
      <View style={styles.formSection}>
        <Text style={styles.paneHeader}>Markets and Dates</Text>
        <Text type="label" style={styles.paneText}>
          Exports only vendors registered in selected Market. Selecting a single
          market date will include an email column for the vendor.
        </Text>
        {this._renderMarketDatesCheckboxes()}
      </View>
    );
  };

  _renderMarketDatesCheckboxes = (): React.ReactNode => {
    let { selectedMarketDates } = this.state;
    let { markets } = this.props;

    if (!markets) {
      return <Text>No market </Text>;
    }
    let filteredMarkets = markets.filter((market) => market.dates.length !== 0);
    return filteredMarkets.mapToArray((market) => (
      <MarketSelector
        key={market.id}
        marketTitle={market.name}
        dates={market.dates}
        selectedItems={selectedMarketDates.get(market.id) || new Set()}
        onSelectAll={() => {
          this._selectAllMarketDates(market.id);
        }}
        onChange={(selectedKey: string) =>
          this._updateColumnMarketDates(market.id, selectedKey)
        }
      />
    ));
  };

  _updateColumnMarketDates = (marketID: string, selection: string) => {
    let { selectedMarketDates } = this.state;
    let newSet = new Set(selectedMarketDates.get(marketID));
    newSet.has(selection) ? newSet.delete(selection) : newSet.add(selection);

    let oldMap = new Map(selectedMarketDates);
    let newMap = oldMap.set(marketID, newSet);
    this.setState({ selectedMarketDates: newMap });
  };

  _selectAllMarketDates = (marketID: string) => {
    let allMarketDates = getAllMarketDates(this.props.markets);

    let { selectedMarketDates } = this.state;
    let oldSet = new Set(selectedMarketDates.get(marketID));
    let newSet =
      oldSet.size > 0
        ? new Set<string>()
        : new Set(allMarketDates.get(marketID));

    let oldMap = new Map(selectedMarketDates);
    let newMap = oldMap.set(marketID, newSet);

    this.setState({ selectedMarketDates: newMap });
  };

  _onSubmit = () => {
    let { account } = this.props;
    let { withTags, withEmails } = this.state;
    if (!account) {
      return;
    }
    let { selectedMarketDates } = this.state;
    this.setState({ isLoading: true });
    let season = dataStore.get('season');
    let data = {
      selectedMarketDates: mapToPlainObject(selectedMarketDates, (dates) =>
        Array.from(dates),
      ),
      authToken: account.token,
      seasonID: season ? season.id : undefined,
      withTags,
      withEmails,
    };
    DownloadTarget.post('/api/placement/export', data);
    this._onHide();
  };

  _onHide = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };
  _checkBoxTags = () => {
    this.setState({ withTags: !this.state.withTags });
  };

  _checkBoxEmail = () => {
    this.setState({ withEmails: !this.state.withEmails });
  };
}

function getAllMarketDates(
  markets: IndexedList<Market> | null | undefined,
): Map<string, Set<string>> {
  let marketDatesMap = new Map();
  if (markets && markets.length !== 0) {
    let newMarkets = markets.mapToArray((x) => x);
    newMarkets.forEach((market) =>
      marketDatesMap.set(market.id, new Set(market.dates)),
    );
  }
  return marketDatesMap;
}

let styles = StyleSheet.create({
  paneHeader: {
    marginBottom: 8,
    fontWeight: '600',
    color: themeColors.darkGrey,
  },
  paneText: {
    color: themeColors.darkGrey,
  },
  formSection: {
    paddingHorizontal: 30,
    paddingTop: 10,
    paddingBottom: 20,
    borderBottomWidth: StyleSheet.hairlineWidth * 2,
    borderColor: themeColors.lightGrey,
  },
  checkbox: {
    position: 'absolute',
    right: 5,
    top: 8,
  },
  optionsWrapper: {
    flex: 1,
    flexDirection: 'row',
  },
});

export default ExportPlacement;
